export default __webpack_public_path__ + "static/media/calendar.2521ce36.svg";